module.exports = __webpack_public_path__ + "img/img_home.c29ffadd.png";